/**
 * Returns a new array with duplicate values removed, preserving insertion order.
 * Uses a Set internally; converts back with Array.from to avoid spread on iterables.
 */
export function deduplicate<T>(items: T[]): T[] {
  return Array.from(new Set(items));
}

/**
 * Splits `items` into consecutive slices of at most `size`, preserving order. Used to bound an unbounded
 * `$in` / batch into fixed-size pieces (e.g. a fleet-wide Mongo read, the reminder sync's batches).
 * @throws RangeError when `size` is not a positive integer — otherwise the loop would never advance.
 * @example chunked([1, 2, 3, 4, 5], 2) => [[1, 2], [3, 4], [5]]
 */
export function chunked<T>(items: T[], size: number): T[][] {
  if (!Number.isInteger(size) || size < 1) {
    throw new RangeError(`chunked size must be a positive integer, received ${String(size)}`);
  }
  const chunks: T[][] = [];
  for (let start = 0; start < items.length; start += size) {
    chunks.push(items.slice(start, start + size));
  }
  return chunks;
}
